import { render } from "./PowerUpsPanel.vue?vue&type=template&id=45700223&scoped=true"
import script from "./PowerUpsPanel.vue?vue&type=script&lang=js"
export * from "./PowerUpsPanel.vue?vue&type=script&lang=js"

import "./PowerUpsPanel.vue?vue&type=style&index=0&id=45700223&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45700223"]])

export default __exports__